import React from "react";
import Header from "../../Components/Header/index"
import Footer from "../../Components/Footer/index"

import {update_status_code} from "../../utility/browser";
import { setRobotsNoindex } from "../../utility/head";

export default class extends React.Component {
    componentDidMount() {
        // update status code
        update_status_code(403);

        setRobotsNoindex();

    }

    render() {
        return (
            <div>
                <Header/>
                <div className="container dr-403">
                    <h1>403 Forbidden</h1>
                    <a href="/">Go to Homepage</a>
                </div>
                <Footer/>
            </div>
        )
    }
}
